import React, { Fragment, useEffect, useState } from 'react';
import { isAdmin, getInfoValue, getGlobalData } from './../lib/globalData';
import { apiPath } from './../lib/isTest';
import { List, Pagination, Create, Edit, Datagrid, SimpleForm, ReferenceInput, AutocompleteInput, 
         TextField, EditButton, Filter, TextInput, SelectInput, FormDataConsumer, 
         DateInput, ReferenceArrayInput, AutocompleteArrayInput, BulkDeleteButton, 
         Show, SimpleShowLayout, ShowButton, FileInput, FileField,
         BooleanInput, RichTextField, TopToolbar, Button
       } from 'react-admin';
import CloseToolbar from './../lib/CloseToolbar';
import dataProvider from './../lib/dataProvider';
import RichTextInput from 'ra-input-rich-text'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
//import { makeStyles } from '@material-ui/core';
//import { Link } from 'react-router-dom';
//import KingBed from '@material-ui/icons/KingBed';
//import { stringify } from 'query-string';
import DeleteIcon from '@material-ui/icons/HighlightOff';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

var d = new Date();
var jahre = [];
for (var j=d.getFullYear(); j>=2008; j--) {
  jahre.push({id:j, jahr:j});
}

const ListFilter = (props) => (
<Filter {...props} >
  <TextInput source="q" label="Suchen" alwaysOn resettable />
  
  <SelectInput optionText="jahr" resettable allowEmpty choices={jahre} source="jahr"/>
  
  <ReferenceInput source="id_cave" label="Höhle" reference="cave"
    perPage={10000} sort={{ field: 'cave_name', order: 'ASC' }} >
    <AutocompleteInput optionText="cavenametouranz" inputValueMatcher={() => null} resettable allowEmpty/>
  </ReferenceInput>
  <ReferenceInput source="id_owner" label="Autor" reference="user"
    perPage={1000} sort={{ field: 'vornamename', order: 'ASC' }} filter={{ tourOwner:1 }} >
    <SelectInput optionText="vornamename" inputValueMatcher={() => null} resettable allowEmpty/>
  </ReferenceInput>
  
  <ReferenceInput source="xuserfilter" label="Teilnehmer" reference="user"
    perPage={100} sort={{ field: 'tour_anz', order: 'DESC'}} filter={{ tourTn:1 }}  >
    <AutocompleteInput optionText="vornamenametouranz" inputValueMatcher={() => null} resettable allowEmpty/>
  </ReferenceInput>
  
  <ReferenceInput source="xactivityfilter" label="Aktivität" reference="activity"
    perPage={100} sort={{ field: 'activity_name', order: 'ASC' }} >
    <SelectInput optionText="activity_name" inputValueMatcher={() => null} resettable allowEmpty/>
  </ReferenceInput>
  <ReferenceInput source="id_region" label="Region" reference="region"
    perPage={100} sort={{ field: 'countryregion_name', order: 'ASC' }} >
    <SelectInput optionText="countryregion_name" inputValueMatcher={() => null} resettable allowEmpty/>
  </ReferenceInput>
  <ReferenceInput source="id_land" label="Land" reference="land"
    perPage={300} sort={{ field: 'land_name', order: 'ASC' }} >
    <SelectInput optionText="land_name" inputValueMatcher={() => null} resettable allowEmpty/>
  </ReferenceInput>
</Filter>
);

const CondEditButton = (props) => {
  const myid = getInfoValue('id');
  if (!isAdmin() && props.record.id_owner!==myid) return null;
  return (
    <span onClick={event => event.stopPropagation()}>
      <EditButton label="" {...props} />
    </span>
  )
}

const TourShowButton = (props) => (
  <span onClick={event => event.stopPropagation()}>
    <ShowButton label="" className="rowbutton" {...props} />
  </span>
)

const DownlaodButton = (props) => {
  const [downloading, setDownloading] = useState(false);

  const createZipFile= async () => {
    setDownloading(true);
    try {
      var token = getGlobalData('token');
      if (!token) {
        token = localStorage.getItem('token');
      }
      const response = await fetch(apiPath+'/tourdownload', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'TourenToken': token},
        body: JSON.stringify({ids: props.selectedIds}),
      });
      if (!response.ok) {
        throw new Error('Download fehlgeschlagen');
      }
      const blob = await response.blob();
      const disposition = response.headers.get('Content-Disposition') || '';
      const match = /filename="([^"]+)"/.exec(disposition);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = match ? match[1] : 'AGN-Touren-Export.zip';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    }
    catch (response) {
      console.error(response);
    }
    finally {
      setDownloading(false);
    }
  }
  return (
    <Button label="Download als zip" style={{marginRight:"130px"}} onClick={createZipFile} disabled={downloading}/>
  )
}
      
const TourBulkActionButtons = props => (
    <Fragment>
        <DownlaodButton {...props} />
        {/* default bulk delete action */}
        {isAdmin() && <BulkDeleteButton {...props} />}
    </Fragment>
);
      
const TourPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 1000, 10000]} {...props} />;
     
const ListForm = (props) => {
  /*
    <TextField source="end_datum" sortable={true} label="End-Datum"/>
    <TextField source="xuserlist" sortable={false} label="Teilnehmer"/>
    comment_titel        
  */
  //const anzbem = props.record.bemerkung ? props.record.bemerkung : props.record.comment_titel;
  return (
    <List {...props} filters={<ListFilter />} title="Touren"  sort={{ field: 'start_datum', order: 'DESC' }} exporter={isAdmin() && props.exporter} bulkActionButtons={<TourBulkActionButtons />} pagination={<TourPagination />}>
      <Datagrid style={{ width: 'auto' }} rowClick="expand" expand={<TourListDetails />}>
        <TextField source="start_datum" sortable={true} label="Datum"/>
        <TextField source="dauerh" sortable={false} label="Dauer" />
        <TextField source="cave_info" sortable={false} label="Höhle"/>
        <TextField source="anztn" sortable={false} label="Personen"/>
        <TextField source="xactivitylist" sortable={false} label="Aktivitäten"/>
        <TextField source="anzbem" sortable={false} label="Bemerkung"/> 
        <TextField source="anzdoc" sortable={false} label="Dok"/> 
        <TextField source="owner_name" sortable={false} label="Author"/>
        <TextField source="id_nita" sortable={false} label="Id"/>
        <TourShowButton />
        <CondEditButton />
      </Datagrid>
    </List>
  )
}

const RTextInputAnhang = (props) => {
  //const myid = getInfoValue('id');
  //if (!isAdmin() && props.record.id_owner!==myid) return null;
  return (
    <RichTextInput source={props.source} fullWidth 
      toolbar={[
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],

        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],

        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

        [{ 'color': [] }, { 'background': [] }],
        [{ 'font': [] }],
        [{ 'align': [] }],

        ['image'],
        ['clean'],
      ]}/>
  )
}
      
const getAttachmentType = (attachment) => {
  const extension = attachment.title ? attachment.title.split('.').pop().toLowerCase() : '';
  if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image';
  if (['mp4', 'mov'].includes(extension)) return 'video';
  if (['m4a', 'mp3'].includes(extension)) return 'audio';
  return 'file';
};

const ImgsField = ({ source, record = {} }) => { 
  const [previewIndex, setPreviewIndex] = useState(false);
  const media = (record.anhang || []).filter(attachment => ['image', 'video'].includes(getAttachmentType(attachment)));
  const preview = media[previewIndex];

  const showPrevious = () => setPreviewIndex((previewIndex + media.length - 1) % media.length);
  const showNext = () => setPreviewIndex((previewIndex + 1) % media.length);
  const handleKeyDown = event => {
    if (event.key==='ArrowLeft' && media.length>1) {
      event.preventDefault();
      showPrevious();
    }
    if (event.key==='ArrowRight' && media.length>1) {
      event.preventDefault();
      showNext();
    }
  };

  if (!media.length) return null;
  return (
    <Fragment>
      <div className="tour-media-grid">
        {media.map((attachment, i) => (
          <button type="button" className="tour-media-tile" key={attachment.id} onClick={() => setPreviewIndex(i)} aria-label={attachment.title}>
          {getAttachmentType(attachment)==='image' ? <img src={attachment.url} alt={attachment.title} /> : <video src={attachment.url} muted preload="metadata" />}
          </button>
        ))}
      </div>
      <Dialog open={previewIndex!==false} onClose={() => setPreviewIndex(false)} onKeyDown={handleKeyDown} maxWidth="lg" fullWidth>
        <IconButton aria-label="Schliessen" onClick={() => setPreviewIndex(false)} style={{ position: 'absolute', right: 0, top: 0, zIndex: 1 }}>
          <CloseIcon />
        </IconButton>
        {media.length>1 ? <IconButton aria-label="Vorheriges Medium" className="tour-media-dialog-previous" onClick={showPrevious}><NavigateBeforeIcon /></IconButton> : null}
        <DialogContent>
          {preview && getAttachmentType(preview)==='image' ? <img className="tour-media-dialog-image" src={preview.url} alt={preview.title} /> : null}
          {preview && getAttachmentType(preview)==='video' ? <video className="tour-media-dialog-video" src={preview.url} controls autoPlay /> : null}
          {preview ? <div className="tour-media-dialog-position">{previewIndex + 1} / {media.length}</div> : null}
        </DialogContent>
        {media.length>1 ? <IconButton aria-label="Nächstes Medium" className="tour-media-dialog-next" onClick={showNext}><NavigateNextIcon /></IconButton> : null}
      </Dialog>
    </Fragment>
  )
};

const PreviewField = ({ source, record = {} }) => {
  const attachments = record.anhang || [];
  const audio = attachments.filter(attachment => getAttachmentType(attachment)==='audio');
  const files = attachments.filter(attachment => getAttachmentType(attachment)==='file');

  return (
    <Fragment>
      {audio.map(attachment => <audio key={attachment.id} className="tour-audio-preview" src={attachment.url} controls />)}
      {files.length ? <div className="tour-attachment-links">
        {files.map(attachment => <a key={attachment.id} href={attachment.url} target="_blank" rel="noopener noreferrer">{attachment.title}</a>)}
      </div> : null}
    </Fragment>
  );
};

const TourAdditionalDetails = ({ record }) => {
  if (!record) return null;
  return (
    <div style={{ width: '100%' }}>
      <Typography>Teilnehmer: {record.xuserlist || '-'}</Typography>
      {record.xcavepartlist ? <Typography>Höhlengebiete: {record.xcavepartlist}</Typography> : null}
      {record.main_comment_id ? <Typography style={{ marginTop: '0.8em' }}>{record.comment_subject || 'Kommentar'}</Typography> : null}
      {record.main_comment_id ? <RichTextField source="comment_text" record={record} stripTags={false} label="" addLabel={false} /> : null}
      <ImgsField record={record} />
      <PreviewField record={record} />
    </div>
  );
};

const TourListDetails = ({ record }) => {
  const [detail, setDetail] = useState(false);

  useEffect(() => {
    let active = true;
    dataProvider.getOne('tour', { id:record.id })
      .then(result => active && setDetail(result.data))
      .catch(() => active && setDetail(record));
    return () => { active = false; };
  }, [record]);

  return detail ? <TourAdditionalDetails record={detail} /> : 'Lade Details …';
};

const TourBackButton = () => (
  <div>
    <Button label="Zurück" variant="outlined" onClick={() => window.history.back()}><ArrowBackIcon /></Button>
  </div>
)

const TourShowActions = ({ basePath, data, resource }) => {
  const myid = getInfoValue('id');
  return (
    <TopToolbar>
      {isAdmin() || data.id_owner===myid ? <EditButton basePath={basePath} record={data} /> : null }
    </TopToolbar>
  )
};

/*
    <TextInput source="subject" label="Betreff" fullWidth />
    <RTextInputAnhang />
    <PreviewField source="preview"/>
    <FileInput source="files" label="AnhÃ¤nge" multiple>
      <FileField source="src" title="title" />
    </FileInput>
    <FormDataConsumer>
       {({ formData, ...rest }) => formData.anhang.map((a)=>
          <BooleanInput source={'del_'+a.id} label={'lÃ¶sche '+a.title} {...rest} options={{checkedIcon: <DeleteIcon /> }} />
         )
       }
    </FormDataConsumer>
*/

const ShowForm = ({classes, hasList, hasEdit, hasCreate, hasShow, ...props}) => {
/*
      {props.record.anhang.length ? <FileField source="anhang" src="url" title="title" target="_blank" style={{width:'100%'}} /> : null }
*/  
  return (
    <SimpleShowLayout toolbar={<CloseToolbar />} {...props}>  
      <TextField source="time_info" label="Datum"/>
      <TextField source="cave_info" label="Höhle"/>
      {props.record.xcavepartlist ? <TextField source="xcavepartlist" label="" addLabel={false}/> : null }
      <TextField source="xactivitylist" label="Aktivitäten"/>
      <TextField source="xuserlist"  label="Teilnehmer"/>
      {props.record.bemerkung ? <TextField source="anzbem" label="Bemerkung"/> : null }
      {props.record.main_comment_id ? <TextField source="comment_subject" label="Titel" /> : null }
      {props.record.main_comment_id ? <RichTextField source="comment_text" stripTags={false} label="" addLabel={false} /> : null }
      <ImgsField />
      <PreviewField source="preview"/>

      <TextField source="owner_name" label="Author"/>
      <TextField source="id_nita" label="ID" />
      <TourBackButton />
    </SimpleShowLayout>
  )
};

const AutocompleteNotEmpty = (props) => {
  if (props.choices && props.choices.length) {
    return (
      <AutocompleteArrayInput {...props}/>
    )
  }
  return null;
}

const EditForm = ({classes, hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  const myid = getInfoValue('id');
  if (!isAdmin() && props.record.id_owner!==myid) return (<h2> Keine Berechtigung</h2>);
  
  /*
      <TextField source="xcavepartlist" sortable={false} label="Höhlengebiet"/>
      <TextField source="xactivitylist" sortable={false} label="Aktivitäten"/>
      <TextField source="xuserlist" sortable={false} label="Teilnehmer"/>

      <FormDataConsumer>
         {({ formData, ...rest }) => formData.anhang.map((a)=>
            <BooleanInput source={'del_'+a.id} label={'lÃ¶sche '+a.title} {...rest} options={{checkedIcon: <DeleteIcon /> }} />
           )
         }
      </FormDataConsumer>
  */
  
  return (
    <SimpleForm toolbar={<CloseToolbar />} {...props}>  
      <FormDataConsumer>
        {({ formData, ...rest }) => 
          <Fragment >
            <TextField source="id" sortable={false} />
            <TextField source="owner_name" sortable={true} label="Author"/>
            <DateInput source="start_datum" sortable={false} label="Datum"/>
            <TextInput source="dauerh" label="Dauer in Stunden" />
            { formData.end_datum || formData.dauer>=10 
              ? <DateInput source="end_datum" sortable={false} label="Datum bis"/>
              : null
            }
            <ReferenceInput label="Höle" source="id_cave" reference="cave" sort={{ field: 'cave_name', order: 'ASC' }} perPage={10000} allowEmpty fullWidth> 
              <AutocompleteInput optionText="cave_name" inputValueMatcher={() => null} />
            </ReferenceInput>
            <ReferenceArrayInput source="xcavepart" reference="cavepart" label="Höhlengebiet" filter={{ id_cave:formData.id_cave }}>
              <AutocompleteNotEmpty optionText="cavepart_name" fullWidth />
            </ReferenceArrayInput>

            <ReferenceArrayInput source="xactivity" reference="activity" label="Aktivitäten">
              <AutocompleteArrayInput optionText="activity_name" fullWidth/>
            </ReferenceArrayInput>
            <ReferenceArrayInput source="xuser" reference="user"  label="Teilnehmer">
              <AutocompleteArrayInput optionText="vornamenametouranz" fullWidth/>
            </ReferenceArrayInput>
            {props.record.bemerkung ? <TextInput source="bemerkung" multiline sortable={false} label="Bemerkung" fullWidth/> : null }
            <TextInput source="comment_subject" label="Titel" fullWidth />
            {formData.comment_subject || formData.comment_text ? <RTextInputAnhang source="comment_text" /> : null }
            
            <FileInput source="files" label="Anhänge" multiple>
              <FileField source="src" title="title" />
            </FileInput>
            <ImgsField {...rest} />
            <PreviewField source="preview" {...rest} />

            {formData.anhang && formData.anhang.map((a)=>
                <BooleanInput source={'del_'+a.id} label={'lösche '+a.title} {...rest} options={{checkedIcon: <DeleteIcon /> }} fullWidth />
              )
            }
          </Fragment >
        }
      </FormDataConsumer>      
    </SimpleForm>
  )
};

export default {
  
  options: { label: "Tour" },
  
  list: (props) => (
    <ListForm {...props} />
  ),
  
  create: (props) => (
    <Create {...props} title="Tour hinzufügen" undoable={false} >
      <SimpleForm toolbar={<CloseToolbar nextstep="edit" />} {...props}> 
        <FormDataConsumer>
          {({ formData, ...rest }) => 
            <Fragment >
              <TextField source="id" sortable={false} />
              <DateInput source="start_datum" sortable={false} label="Datum"/>
              <TextInput source="dauerh" label="Dauer in Stunden" />
              { formData.dauerh>=10 
                ? <DateInput source="end_datum" sortable={false} label="Datum bis"/>
                : null
              }
              <ReferenceInput label="Höhle" source="id_cave" reference="cave" sort={{ field: 'cave_name', order: 'ASC' }} perPage={10000} allowEmpty>
                <AutocompleteInput optionText="cave_name" inputValueMatcher={() => null}  />
              </ReferenceInput>
            </Fragment >
          }
        </FormDataConsumer>      
      </SimpleForm>
    </Create>
  ),
  
  show: (props) => (
    <Show actions={<TourShowActions />} {...props}>
      <ShowForm {...props} />
    </Show>
  ),
  
  edit: (props) => (
    <Edit title="Tour bearbeiten" undoable={false} {...props}>
      <EditForm {...props} />
    </Edit>
  )
}   
